import React, { useState, useEffect } from 'react';
import { Modal, Button, DatePicker, TimePicker, Input, Typography } from 'antd';
import dayjs from 'dayjs';

const { TextArea } = Input;
const { Title } = Typography;

interface SessionModalProps {
  isOpen: boolean;
  onClose: () => void;
  gameTime: string;
  sessionNotes: string;
  onUpdateSessionNotes: (notes: string) => void;
  onSetGameTime: (newTime: string) => void;
}

const SessionModal: React.FC<SessionModalProps> = ({
  isOpen,
  onClose,
  gameTime,
  sessionNotes,
  onUpdateSessionNotes,
  onSetGameTime,
}) => {
  const [notes, setNotes] = useState(sessionNotes);

  useEffect(() => {
    if (isOpen) {
      setNotes(sessionNotes);
    }
  }, [isOpen, sessionNotes]);

  const handleSave = () => {
    onUpdateSessionNotes(notes);
    onClose();
  };

  const handleTimeChange = (time: dayjs.Dayjs | null) => {
    if (time) {
      const current = dayjs(gameTime);
      const newDateTime = current.hour(time.hour()).minute(time.minute()).second(time.second());
      onSetGameTime(newDateTime.toISOString());
    }
  };

  const handleDateChange = (date: dayjs.Dayjs | null) => {
    if (date) {
      const current = dayjs(gameTime);
      const newDateTime = date.hour(current.hour()).minute(current.minute()).second(current.second());
      onSetGameTime(newDateTime.toISOString());
    }
  };

  return (
    <Modal
      title="Session Management"
      open={isOpen}
      onCancel={onClose}
      width={600}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          Save & Close
        </Button>,
      ]}
    >
      <Title level={5}>Game Time</Title>
      <DatePicker value={dayjs(gameTime)} onChange={handleDateChange} />
      <TimePicker value={dayjs(gameTime)} onChange={handleTimeChange} style={{ marginLeft: 8 }} />

      <Title level={5} style={{ marginTop: '1rem' }}>Session Notes</Title>
      <TextArea rows={10} value={notes} onChange={(e) => setNotes(e.target.value)} />
    </Modal>
  );
};

export default SessionModal;